var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'library-card-skeleton',
    {
      'library-card-skeleton--style': _vm.libraryType === _vm.LIBRARY_TYPE.STYLE
    }
  ]},[_c('div',{staticClass:"library-card-skeleton__favorite"}),_c('div',{staticClass:"library-card-skeleton__image"}),_c('div',{staticClass:"library-card-skeleton__body"},[_c('div',{staticClass:"library-card-skeleton__title"}),_c('div',{staticClass:"library-card-skeleton__subtitle"}),_c('div',{class:[
        'library-card-skeleton__badge',
        {
          'library-card-skeleton__badge--style':
            _vm.libraryType === _vm.LIBRARY_TYPE.STYLE
        }
      ]})])])}
var staticRenderFns = []

export { render, staticRenderFns }